export const setAuthTokens = (access: string, refresh: string) => {
    sessionStorage.setItem('access_token', access);
    sessionStorage.setItem('refresh_token', refresh);
};

export const getAccessToken = () => sessionStorage.getItem('access_token');
export const getRefreshToken = () => sessionStorage.getItem('refresh_token');

export const clearAuthTokens = () => {
    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('refresh_token');
};

export const getAuthToken = getAccessToken;
export const clearAuthToken = clearAuthTokens;

export const AUTHORIZATION_HEADER_NAME = 'Authorization';
